<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/195wj3c/tc-custom/9781460310113.jpg?1706960743001" alt="This image is the cover for the book Marry Me, Mendoza!, The Fortunes of Texas: Southern Invasion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marry Me, Mendoza!, The Fortunes of Texas: Southern Invasion
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>USA Today–</i>bestselling author: A woman forced to marry to meet her parents’ demands asks the man she once loved to be her convenient husband.</b><br/><br/>Second-chance sweethearts?<br/><br/>Nicole Castleton was a shrewd businesswoman with a Texas-sized stubborn streak. She needed a husband in a hurry, and no one but her ex, Miguel Mendoza, would do! Yet she had her doubts—sweet, sexy Miguel still shook her to the core of her expensive Castleton boots. And when it came right down to it, she still desired the man beyond words.<br/><br/>Was it a ghost standing on his doorstep? Or could this really be his Nicole? The girl who broke Miguel’s heart ten years ago was back—with a crazy proposal for a strictly business marriage! A desire for payback—and one last round of romance with the one who’d gotten away—tempted Miguel beyond any dollar amount. But this time, he wasn’t so sure he’d be able to walk away from the woman of his dreams. . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judy Duarte
      </h2>
      
      <p class="authorDescription body article">Twenty-four years ago,<I> USA Today </I>bestselling author Judy Duarte couldn&rsquo;t shake the dream of creating a story of her own. That dream became a reality in 2002, when Harlequin released the first of more than sixty books. Judy&#39;s stories have touched the hearts of readers around the world. A two-time Rita finalist, Judy&#39;s books won two Maggies and a National Reader&rsquo;s Choice Award. You can contact her at <a href="http://www.judyduarte.com">www.judyduarte.com</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c0ed487e